class SizeGuideDrawer extends Theme.Component {
  constructor() {
    super();
    this.events();
  }

  connectedCallback() {
    document.addEventListener("sizeguidedrawer:click", () => {
      this.show();
    });
  }

  show() {
    setTimeout(() => {
      this.classList.add("state--active");
    }, 50);
  }

  hide() {
    this.classList.remove("state--active");
  }
}
customElements.define("size-guide-drawer", SizeGuideDrawer);